require('array.prototype.find').shim();
require('array.prototype.findindex').shim();
require('es6-object-assign').polyfill();
require('es6-promise').polyfill();



//////////////////
// WEBPACK FOOTER
// ./~/groupby-api/dist/src/polyfills.js
// module id = 124
// module chunks = 0